import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { STRINGS } from "../Strings";
import PageHero from "./PageHero"; 

// Imports zote za picha ziko hapa juu pekee
import bgHeroImg from "../assets/elders.jpg";
import visionImg from "../assets/youth.jpg";
import missionImg from "../assets/orphans.jpg";
import historyBg from "../assets/poor.jpg";
import valuesBg from "../assets/values.jpg";
import passport from "../assets/passport.jpg";
// import leaderChair from "../assets/chairperson.jpg";
// import leaderSec from "../assets/secretary.jpg";
// import leaderTreas from "../assets/treasurer.jpg";

import { FaTwitter, FaLinkedin, FaEnvelope } from "react-icons/fa";

export default function AboutUsContent(props) {
    const appContext = useContext(AppContext);
    const language = appContext.language || "sw";
    const s = STRINGS.aboutUsPage;

    const [ready, setReady] = useState(false);

    async function init() {
        setReady(false);
        // Space for initialization if needed
        setReady(true);
    }

    useEffect(() => {
        init();
    }, []);

    if (ready) {
        return (
            <div className="about-page-wrapper">
                {/* 1. Page Hero Section Call */}
                <PageHero 
                    kicker={s.hero.kicker[language]} 
                    title={s.hero.title[language]} 
                    bgImage={bgHeroImg} 
                />

                {/* 2. Vision and Mission Grid Section */}
                <section className="MainBodySection py-5 backgroundColor">
                    <div className="container py-3">
                        {/* Row 1: Vision (Left Box) & Image (Right Box) */}
                        <div className="row g-0 align-items-stretch mb-4 mb-md-5">
                            <div className="col-12 col-md-6 d-flex">
                                <div className="vm-square-box w-100 p-4 p-md-5 d-flex flex-column justify-content-center">
                                    <h2 className="title-font-bold text-uppercase mb-3 primaryColor-text">{s.vision.title[language]}</h2>
                                    <p className="font-regular mb-0 text-dark lh-base">{s.vision.desc[language]}</p>
                                </div>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="vm-matching-img w-100 h-100" style={{ backgroundImage: `url(${visionImg})` }}></div>
                            </div>
                        </div>

                        {/* Row 2: Image (Left Box) & Mission (Right Box) on Desktop */}
                        <div className="row g-0 align-items-stretch flex-column-reverse flex-md-row">
                            <div className="col-12 col-md-6">
                                <div className="vm-matching-img w-100 h-100" style={{ backgroundImage: `url(${missionImg})` }}></div>
                            </div>
                            <div className="col-12 col-md-6 d-flex">
                                <div className="vm-square-box w-100 p-4 p-md-5 d-flex flex-column justify-content-center">
                                    <h2 className="title-font-bold text-uppercase mb-3 primaryColor-text">{s.mission.title[language]}</h2>
                                    <p className="font-regular mb-0 text-dark lh-base">{s.mission.desc[language]}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* 3. Preamble & History Section (Slow Moving Scrolling Background) */}
                <section className="history-slow-scroll position-relative overflow-hidden py-5" style={{ backgroundImage: `url(${historyBg})` }}>
                    <div className="history-primary-overlay"></div>
                    <div className="container position-relative z-index-3 py-5">
                        <div className="row justify-content-center">
                            <div className="col-12 col-lg-10 text-center">
                                <div className="history-transparent-card p-4 p-md-5 mx-auto d-flex align-items-center justify-content-center">
                                    <div className="history-content-center">
                                        <h2 className="title-font-semi-bold text-white mb-4">{s.history.title[language]}</h2>
                                        <p className="font-regular text-white-75 mb-0 lh-lg">{s.history.desc[language]}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* 4. Our Team Section (surfaceColor Background, Profile Circle Painting Design) */}
                <section className="MainBodySection py-5 team-surface-bg">
                    <div className="container py-4">
                        <div className="text-center mb-5">
                            <h2 className="title-font-bold primaryColor-text text-uppercase m-0">{s.team.title[language]}</h2>
                            <div className="team-center-bar mx-auto mt-2"></div>
                        </div>

                        <div className="row g-4 justify-content-center">
                            {/* Chairperson Card */}
                            <div className="col-12 col-md-4">
                                <div className="leader-painted-profile text-center p-3">
                                    <div className="leader-circle-avatar mx-auto mb-3" style={{ backgroundImage: `url(${passport})` }}></div>
                                    <div className="title-font-light text-muted text-uppercase small-tracking">{s.team.chairperson.role[language]}</div>
                                    <h4 className="title-font-semi-bold primaryColor-text mt-1 mb-2">{s.team.chairperson.name}</h4>
                                    <p className="font-light text-muted small px-2 mb-3">{s.team.chairperson.desc[language]}</p>
                                    <div className="leader-social-row d-flex justify-content-center gap-3">
                                        <a href="#" className="muted-social-btn"><FaTwitter size={16} /></a>
                                        <a href="#" className="muted-social-btn"><FaLinkedin size={16} /></a>
                                        <a href="#" className="muted-social-btn"><FaEnvelope size={16} /></a>
                                    </div>
                                </div>
                            </div>

                            {/* General Secretary Card */}
                            <div className="col-12 col-md-4">
                                <div className="leader-painted-profile text-center p-3">
                                    <div className="leader-circle-avatar mx-auto mb-3" style={{ backgroundImage: `url(${passport})` }}></div>
                                    <div className="title-font-light text-muted text-uppercase small-tracking">{s.team.secretary.role[language]}</div>
                                    <h4 className="title-font-semi-bold primaryColor-text mt-1 mb-2">{s.team.secretary.name}</h4>
                                    <p className="font-light text-muted small px-2 mb-3">{s.team.secretary.desc[language]}</p>
                                    <div className="leader-social-row d-flex justify-content-center gap-3">
                                        <a href="#" className="muted-social-btn"><FaTwitter size={16} /></a>
                                        <a href="#" className="muted-social-btn"><FaLinkedin size={16} /></a>
                                        <a href="#" className="muted-social-btn"><FaEnvelope size={16} /></a>
                                    </div>
                                </div>
                            </div>

                            {/* Treasurer Card */}
                            <div className="col-12 col-md-4">
                                <div className="leader-painted-profile text-center p-3">
                                    <div className="leader-circle-avatar mx-auto mb-3" style={{ backgroundImage: `url(${passport})` }}></div>
                                    <div className="title-font-light text-muted text-uppercase small-tracking">{s.team.treasurer.role[language]}</div>
                                    <h4 className="title-font-semi-bold primaryColor-text mt-1 mb-2">{s.team.treasurer.name}</h4>
                                    <p className="font-light text-muted small px-2 mb-3">{s.team.treasurer.desc[language]}</p>
                                    <div className="leader-social-row d-flex justify-content-center gap-3">
                                        <a href="#" className="muted-social-btn"><FaTwitter size={16} /></a>
                                        <a href="#" className="muted-social-btn"><FaLinkedin size={16} /></a>
                                        <a href="#" className="muted-social-btn"><FaEnvelope size={16} /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* 5. Core Values Section (Normal Scrolling Background & Primary Overlay) */}
                <section className="values-normal-scroll position-relative py-5" style={{ backgroundImage: `url(${valuesBg})` }}>
                    <div className="values-primary-overlay"></div>
                    <div className="container position-relative z-index-3 py-4">
                        <div className="text-center mb-5">
                            <h2 className="title-font-bold text-white text-uppercase m-0">{s.values.title[language]}</h2>
                            <div className="values-center-bar mx-auto mt-2"></div>
                        </div>

                        <div className="row g-4 justify-content-center">
                            {s.values.items.map((item, index) => (
                                <div className="col-12 col-md-6 col-lg-4" key={index}>
                                    <div className="value-premium-card h-100 p-4">
                                        <div className="value-card-index title-font-bold mb-2">0{index + 1}</div>
                                        <h4 className="title-font-semi-bold text-white mb-2">{item.title[language]}</h4>
                                        <p className="font-regular text-white-75 small mb-0">{item.desc[language]}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </div>
        );
    } else {
        return (
            <div className="container mSupportLoading d-flex justify-content-center align-items-center" style={{ height: "150px" }}>
                {getInlineLoader()}
            </div>
        );
    }
}